import React, { useState, useEffect } from 'react';
import Home from './Home';
import User from './User';
import FooterNav from '../components/FooterNav';
import getCheckIfBookPurchased from '../api/get/getCheckIfBookPurchased';
import { auth } from '../config';
import { onAuthStateChanged } from 'firebase/auth';
import getUser from '../api/get/getUser';
import Settings from './Settings';
import NewsModal from '../modals/NewsModal';
import IosSplash from '../animations/IosSplash';
import fetchBooksAndShowNews from '../utils/fetchBooksAndShowNews';

function Main() {
    const [activeTab, setActiveTab] = useState('home');
    const [bookId, setBookId] = useState(null);
    const [userData, setUserData] = useState(null);
    const [userProfilePicture, setUserProfilePicture] = useState(null);
    const [newsModalOpen, setNewsModalOpen] = useState(false);
    const [newsItem, setNewsItem] = useState(null);
    const [centerText, setCenterText] = useState(null);

    // Алдыңғы таңдаған табты localStorage-тен жүктеу
    useEffect(() => {
        const savedTab = localStorage.getItem('activeTab');
        if (savedTab) setActiveTab(savedTab);
    }, []);

    // Firebase аутентификациядан пайдаланушыны бақылау
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            if (user) {
                const data = await getUser({ user_id: user.uid });
                if (data) {
                    setUserData(data);
                    setUserProfilePicture(data.photoURL);
                }
            }
        });
        return () => unsubscribe();
    }, []);

    useEffect(() => {
        fetchBooksAndShowNews(setNewsItem, setNewsModalOpen);
    }, []);

    const handleTabChange = (tab) => {
        setActiveTab(tab);
        localStorage.setItem('activeTab', tab);
    };

    const onPlay = async (bookId, isPaid) => {
        const hasAccess = await getCheckIfBookPurchased(bookId);
        if (!isPaid || hasAccess) {
            setBookId(bookId);
        } else {
            console.log('Access denied to book ID:', bookId);
        }
    };

    return (
        <div className="relative h-screen bg-[var(--bg-color)] text-[var(--text-color)]">
            <IosSplash />
            <NewsModal
                isOpen={newsModalOpen}
                onClose={() => setNewsModalOpen(false)}
                newsItem={newsItem}
            />

            <div className="relative">
                <div className={`${activeTab === 'home' ? 'block' : 'hidden'}`}>
                    <Home
                        onPlay={onPlay}
                        setCenterText={setCenterText}
                    />
                </div>
                <div className={`${activeTab === 'library' ? 'block' : 'hidden'}`}>
                    <User />
                </div>
                <div className={`${activeTab === 'profile' ? 'block' : 'hidden'}`}>
                    <Settings userData={userData} />
                </div>
            </div>
            <FooterNav
                activeTab={activeTab}
                handleTabChange={handleTabChange}
                bookId={bookId}
                userProfilePicture={userProfilePicture}
                centerText={centerText}
            />
        </div>
    );
}

export default Main;